'use client';

import { useRouter } from 'next/navigation';
import { FC, useEffect } from 'react';

import Portal from '@/components/core/Portal';
import useLocalStorage from '@/hooks/useLocalStorage';
import { useTranslation } from '@/hooks/useTranslations';

import './styles.scss';

const DisclaimerModal: FC = () => {
  const router = useRouter();
  const [ageConfirmedData, setAgeConfirmedData] = useLocalStorage('ageConfirmed', {
    value: false,
    expiration: 0,
  });

  const { t } = useTranslation();

  const handleConfirm = () => {
    const expirationTime = new Date().getTime() + 24 * 60 * 60 * 1000;
    setAgeConfirmedData({ value: true, expiration: expirationTime });
  };

  const handleDeny = () => {
    router.push('/en');
    const expirationTime = new Date().getTime() + 24 * 60 * 60 * 1000;
    setAgeConfirmedData({ value: true, expiration: expirationTime });
  };

  useEffect(() => {
    const now = new Date().getTime();
    if (ageConfirmedData.expiration && now > ageConfirmedData.expiration) {
      setAgeConfirmedData({ value: false, expiration: 0 });
    }

    if (!ageConfirmedData.value) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [ageConfirmedData, setAgeConfirmedData]);

  if (ageConfirmedData.value) return null;

  return (
    <Portal id="modal-container">
      <div className="popupWrp">
        <div className="popupInner disclaimer">
          <div className="disclaimer-popup-content">
            {/* <div className="close-disclaimer-popup-block">
              <i className="bc-i-close close-disclaimer-icon" />
            </div> */}
            <div className="disclaimer-popup-info">
              <p className="disclaimer-popup-title">{t('popok18Years')}</p>
              <p className="disclaimer-popup-desc">{t('confirmText')}</p>
            </div>
            <div className="disclaimer-pop-btn-wrp">
              <button onClick={handleConfirm} className="button btnTypeBig fullWidth btnTypeGreen">
                <p>{t('18_PLUS_OK_TEXT')}</p>
              </button>
              <button
                onClick={handleDeny}
                className="button btnTypeBig fullWidth btnTypeTransparent"
              >
                <p> {t('confirmNo-No-take-me-back')} </p>
              </button>
            </div>
          </div>
        </div>
      </div>
    </Portal>
  );
};

export default DisclaimerModal;
